<template>
    <b-modal
        id="module-show-motivation"
        v-model="modal"
        :title="$t('modules.view_motivation')"
        ok-only
        modal-class="apprentice-default-modal"
        :ok-title="$t('common.close')">
        <p v-if="module && module.motivation">
            {{ module.motivation }}
        </p>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-module-management-edit-participant-motivation-modal-component',
    data() {
        return {
            modal: false,
            module: null,
        };
    },
    methods: {
        show(module) {
            this.module = module;
            this.modal = true;
        },
    },
};
</script>

<style scoped></style>
